import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import a7m4Logo  from "../../Assets/tool/a7m4.png";
import acLogo  from "../../Assets/tool/ac.png";
import mini4Logo  from "../../Assets/tool/mini4.png";
import wenLogo  from "../../Assets/tool/wen.png";

import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiGit,
  DiJava,
} from "react-icons/di";
import {
  SiRedis,
  SiFirebase,
  SiNextdotjs,
  SiSolidity,
  SiPostgresql,
} from "react-icons/si";
import { TbBrandGolang } from "react-icons/tb";

function Technology() {
  const tools = [
    { src: a7m4Logo, alt: "Sony A7M4" },
    { src: acLogo, alt: "DJI Action3" },
    { src: mini4Logo, alt: "DJI Mini4Pro" },
    { src: wenLogo, alt: "DJI RS3" },
  ];

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {tools.map((tool, index) => (
        <Col xs={4} md={2} className="tech-icons" key={index}>
          <img
            src={tool.src}
            alt={tool.alt}
            style={{
              width: "80px",
              height: "80px",
              objectFit: "contain",
              marginBottom: "10px",
            }}
          />
          <p style={{ marginTop: "8px", fontSize: "18px", color: "#ccc" }}>
           {tool.alt}
          </p>
        </Col>
      ))}
    </Row>
  );
}

export default Technology;
